(function () {
  'use strict';

  try {
    if (!document.querySelector('[data-tl-card], [data-tl-answer], [data-tl-sticky]')) {
      return;
    }

    // Weight comes before chest measurement: most owners know weight off the
    // top of their head and rarely have a measuring tape handy at read time.
    var TL_SIZES = {
      PP: { minKg: 2, maxKg: 5, minCm: 33, maxCm: 43 },
      P: { minKg: 4, maxKg: 7, minCm: 43, maxCm: 56 },
      M: { minKg: 7, maxKg: 18, minCm: 56, maxCm: 69 },
      G: { minKg: 18, maxKg: 30, minCm: 69, maxCm: 81 },
      GG: { minKg: 30, maxKg: 50, minCm: 81, maxCm: 107 }
    };

    var TRUST_BADGES = ['90 dias para teste', 'Garantia de 12 meses', 'Frete incluso'];

    var currencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    var productCache = {};

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    function formatCents(cents) {
      return currencyFormatter.format((cents || 0) / 100);
    }

    function weightRangeLabel(size) {
      return size.minKg + ' a ' + size.maxKg + ' kg';
    }

    function chestRangeLabel(size) {
      return size.minCm + ' a ' + size.maxCm + ' cm';
    }

    function fetchProduct(handle) {
      if (!productCache[handle]) {
        productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('tl-blog-cta: falha ao buscar /products/' + handle + '.js (' + res.status + ')');
            return res.json();
          });
      }
      return productCache[handle];
    }

    // Exact match only: "P" must never match "PP", "G" must never match "GG".
    function findAvailableVariant(product, sizeLetter) {
      var candidates = product.variants.filter(function (v) {
        return v.options[1] === sizeLetter;
      });
      var available = candidates.filter(function (v) { return v.available; });
      return available[0] || null;
    }

    function fallbackVariant(product) {
      return product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    }

    function resizeImage(url, width) {
      if (!url) return url;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'width=' + width;
    }

    function variantImage(product, variant) {
      var src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || (product.images && product.images[0]);
      return resizeImage(src, 600);
    }

    function parseSizeAttr(raw) {
      if (!raw) return { mode: 'none' };
      if (raw === 'all') return { mode: 'all' };
      if (raw.indexOf('|') !== -1) {
        var parts = raw.split('|');
        if (parts.length === 2 && TL_SIZES[parts[0]] && TL_SIZES[parts[1]]) {
          return { mode: 'dual', a: parts[0], b: parts[1] };
        }
        console.warn('tl-blog-cta: data-tl-size duplo inválido: "' + raw + '"');
        return { mode: 'none' };
      }
      if (TL_SIZES[raw]) return { mode: 'simple', single: raw };
      console.warn('tl-blog-cta: data-tl-size desconhecido: "' + raw + '"');
      return { mode: 'none' };
    }

    function sizeBlockHtml(sizeInfo, breed) {
      if (sizeInfo.mode === 'simple') {
        var s = TL_SIZES[sizeInfo.single];
        var line1 = breed ? escapeHtml(breed) + ': tamanho ' + sizeInfo.single : 'Tamanho recomendado: ' + sizeInfo.single;
        return (
          '<div class="tl-card__size">' +
            '<p class="tl-card__size-main">' + line1 + '</p>' +
            '<p class="tl-card__size-sub">Para cães de ' + weightRangeLabel(s) + ' &middot; peito de ' + chestRangeLabel(s) + '</p>' +
          '</div>'
        );
      }
      if (sizeInfo.mode === 'dual') {
        var a = TL_SIZES[sizeInfo.a];
        var threshold = a.maxKg;
        var breedLabel = breed ? escapeHtml(breed) : 'Seu cão';
        return (
          '<div class="tl-card__size">' +
            '<p class="tl-card__size-main">' + breedLabel + ': ' + sizeInfo.a + ' ou ' + sizeInfo.b + '</p>' +
            '<p class="tl-card__size-sub">Até ' + threshold + ' kg &rarr; ' + sizeInfo.a + ' &middot; acima de ' + threshold + ' kg &rarr; ' + sizeInfo.b + '</p>' +
            '<p class="tl-card__size-note">Na dúvida entre os dois, escolha o maior.</p>' +
          '</div>'
        );
      }
      if (sizeInfo.mode === 'all') {
        var cells = ['PP', 'P', 'M', 'G', 'GG'].map(function (letter) {
          var s2 = TL_SIZES[letter];
          return '<div class="tl-card__size-cell"><strong>' + letter + '</strong> ' + s2.minKg + '-' + s2.maxKg + 'kg</div>';
        }).join('');
        return '<div class="tl-card__size tl-card__size--table">' + cells + '</div>';
      }
      return '';
    }

    function primaryCta(handle, sizeInfo, variant, isFallback) {
      if (isFallback || sizeInfo.mode !== 'simple') {
        var href = '/products/' + handle;
        var label = isFallback ? 'Ver tamanhos disponíveis'
          : sizeInfo.mode === 'dual' ? 'Ver tamanho ' + sizeInfo.a + ' ou ' + sizeInfo.b
          : sizeInfo.mode === 'all' ? 'Ver todos os tamanhos'
          : 'Comprar agora';
        return { href: href, label: label, variantId: null };
      }
      return {
        href: '/products/' + handle + '?variant=' + variant.id,
        label: 'Ver tamanho ' + sizeInfo.single,
        variantId: variant.id
      };
    }

    function buildCardMarkup(el, handle, product) {
      var pos = el.getAttribute('data-tl-pos') || '';
      var sizeInfo = parseSizeAttr(el.getAttribute('data-tl-size'));
      var breed = el.getAttribute('data-tl-breed') || '';
      var badge = el.getAttribute('data-tl-badge') || '';
      var pitch = el.getAttribute('data-tl-pitch') || '';

      var isFallback = false;
      var variant;
      if (sizeInfo.mode === 'simple') {
        variant = findAvailableVariant(product, sizeInfo.single);
        if (!variant) {
          console.warn('tl-blog-cta: nenhuma variante disponível para o tamanho "' + sizeInfo.single + '" em ' + handle + '. Redirecionando para a página do produto sem pré-seleção.');
          variant = fallbackVariant(product);
          isFallback = true;
        }
      } else {
        variant = fallbackVariant(product);
      }

      var cta = primaryCta(handle, sizeInfo, variant, isFallback);
      var img = variantImage(product, variant);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      var installment = formatCents(Math.round(variant.price / 6));

      el.innerHTML =
        '<div class="tl-card__media">' +
          '<img class="tl-card__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="600" height="600">' +
        '</div>' +
        '<div class="tl-card__body">' +
          (badge ? '<span class="tl-card__badge">' + escapeHtml(badge) + '</span>' : '') +
          '<h3 class="tl-card__title">' + escapeHtml(product.title) + '</h3>' +
          (pitch ? '<p class="tl-card__pitch">' + escapeHtml(pitch) + '</p>' : '') +
          sizeBlockHtml(sizeInfo, breed) +
          '<div class="tl-card__price">' +
            '<span class="tl-card__price-current">' + formatCents(variant.price) + '</span>' +
            (hasCompare ? '<span class="tl-card__price-compare">' + formatCents(variant.compare_at_price) + '</span>' : '') +
          '</div>' +
          '<p class="tl-card__installment">ou 6x de ' + installment + ' sem juros</p>' +
          '<ul class="tl-card__trust">' + TRUST_BADGES.map(function (t) { return '<li>' + escapeHtml(t) + '</li>'; }).join('') + '</ul>' +
          '<div class="tl-card__actions">' +
            '<a class="tl-card__btn tl-card__btn--primary" href="' + escapeHtml(cta.href) + '" ' +
              'data-tl-track data-tl-cta-position="' + escapeHtml(pos) + '" data-tl-cta-handle="' + escapeHtml(handle) + '" data-tl-cta-variant="' + (cta.variantId || '') + '">' +
              escapeHtml(cta.label) +
            '</a>' +
            '<a class="tl-card__btn tl-card__btn--secondary" href="/products/' + escapeHtml(handle) + '" ' +
              'data-tl-track data-tl-cta-position="' + escapeHtml(pos) + '" data-tl-cta-handle="' + escapeHtml(handle) + '" data-tl-cta-variant="">' +
              'Ver todas as cores' +
            '</a>' +
          '</div>' +
        '</div>';

      el.classList.remove('tl-card--loading');
      el.classList.add('tl-card--ready');
    }

    function hydrateCard(el) {
      var handle = el.getAttribute('data-tl-card');
      if (!handle) return;
      el.classList.add('tl-card', 'tl-card--loading');
      fetchProduct(handle)
        .then(function (data) { buildCardMarkup(el, handle, data.product); })
        .catch(function (err) {
          console.warn('tl-blog-cta:', err);
          el.classList.remove('tl-card--loading');
          el.innerHTML = '<a class="tl-card__fallback-link" href="/products/' + escapeHtml(handle) + '">Ver produto</a>';
        });
    }

    function buildAnswerMarkup(el, handle, product) {
      var sizeInfo = parseSizeAttr(el.getAttribute('data-tl-size'));
      var text = el.getAttribute('data-tl-text') || '';
      var isFallback = false;
      var variant;
      if (sizeInfo.mode === 'simple') {
        variant = findAvailableVariant(product, sizeInfo.single);
        if (!variant) {
          variant = fallbackVariant(product);
          isFallback = true;
        }
      } else {
        variant = fallbackVariant(product);
        isFallback = true;
      }
      var href = isFallback ? '/products/' + handle : '/products/' + handle + '?variant=' + variant.id;

      el.innerHTML =
        '<span class="tl-answer__label">Resposta rápida</span>' +
        '<p class="tl-answer__text">' + escapeHtml(text) +
          ' <a class="tl-answer__link" href="' + escapeHtml(href) + '" data-tl-track data-tl-cta-position="answer" data-tl-cta-handle="' + escapeHtml(handle) + '" data-tl-cta-variant="' + (isFallback ? '' : variant.id) + '">Ver produto</a>' +
        '</p>' +
        '<p class="tl-answer__note">A comparação completa está logo abaixo.</p>';

      el.classList.remove('tl-answer--loading');
      el.classList.add('tl-answer--ready');
    }

    function hydrateAnswer(el) {
      var handle = el.getAttribute('data-tl-product');
      if (!handle) return;
      el.classList.add('tl-answer', 'tl-answer--loading');
      fetchProduct(handle)
        .then(function (data) { buildAnswerMarkup(el, handle, data.product); })
        .catch(function (err) {
          console.warn('tl-blog-cta:', err);
          el.classList.remove('tl-answer--loading');
          el.innerHTML = '<a class="tl-answer__fallback-link" href="/products/' + escapeHtml(handle) + '">Ver produto</a>';
        });
    }

    function buildStickyMarkup(el, handle, product) {
      var sizeInfo = parseSizeAttr(el.getAttribute('data-tl-size'));
      var isFallback = false;
      var variant;
      if (sizeInfo.mode === 'simple') {
        variant = findAvailableVariant(product, sizeInfo.single);
        if (!variant) {
          variant = fallbackVariant(product);
          isFallback = true;
        }
      } else {
        variant = fallbackVariant(product);
        isFallback = true;
      }
      var href = isFallback ? '/products/' + handle : '/products/' + handle + '?variant=' + variant.id;
      var img = variantImage(product, variant);
      var dismissKey = 'tl_sticky_dismissed_' + handle;

      if (sessionStorage.getItem(dismissKey)) {
        el.remove();
        return null;
      }

      el.innerHTML =
        '<img class="tl-sticky__img" src="' + escapeHtml(resizeImage(img, 100)) + '" alt="" loading="lazy" width="44" height="44">' +
        '<div class="tl-sticky__info">' +
          '<span class="tl-sticky__name">' + escapeHtml(product.title) + '</span>' +
          '<span class="tl-sticky__price">' + formatCents(variant.price) + '</span>' +
        '</div>' +
        '<a class="tl-sticky__btn" href="' + escapeHtml(href) + '" data-tl-track data-tl-cta-position="sticky" data-tl-cta-handle="' + escapeHtml(handle) + '" data-tl-cta-variant="' + (isFallback ? '' : variant.id) + '">Comprar</a>' +
        '<button type="button" class="tl-sticky__close" aria-label="Fechar">&times;</button>';

      el.querySelector('.tl-sticky__close').addEventListener('click', function () {
        sessionStorage.setItem(dismissKey, '1');
        el.classList.remove('tl-sticky--visible');
        document.body.classList.remove('tl-sticky-active');
      });

      return el;
    }

    function hydrateSticky(el) {
      var handle = el.getAttribute('data-tl-product');
      if (!handle) return;
      el.classList.add('tl-sticky');
      fetchProduct(handle)
        .then(function (data) {
          var ready = buildStickyMarkup(el, handle, data.product);
          if (!ready) return;
          initStickyScroll(ready);
        })
        .catch(function (err) {
          console.warn('tl-blog-cta:', err);
          el.remove();
        });
    }

    function initStickyScroll(el) {
      var ticking = false;
      var mobileQuery = window.matchMedia('(max-width: 767px)');

      function evaluate() {
        ticking = false;
        if (!mobileQuery.matches) {
          el.classList.remove('tl-sticky--visible');
          document.body.classList.remove('tl-sticky-active');
          return;
        }
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
        if (progress >= 0.25) {
          el.classList.add('tl-sticky--visible');
          document.body.classList.add('tl-sticky-active');
        }
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(evaluate);
        }
      }, { passive: true });

      evaluate();
    }

    function initTracking() {
      document.addEventListener('click', function (e) {
        var target = e.target.closest('[data-tl-track]');
        if (!target) return;
        try {
          var payload = {
            cta_position: target.getAttribute('data-tl-cta-position') || '',
            product_handle: target.getAttribute('data-tl-cta-handle') || '',
            variant_id: target.getAttribute('data-tl-cta-variant') || null,
            post_path: window.location.pathname
          };
          if (typeof gtag === 'function') {
            gtag('event', 'blog_cta_click', payload);
          }
          if (window.dataLayer) {
            window.dataLayer.push(Object.assign({ event: 'blog_cta_click' }, payload));
          }
        } catch (err) {
          console.warn('tl-blog-cta: falha ao rastrear clique', err);
        }
      });
    }

    function init() {
      document.querySelectorAll('[data-tl-card]').forEach(hydrateCard);
      document.querySelectorAll('[data-tl-answer]').forEach(hydrateAnswer);
      document.querySelectorAll('[data-tl-sticky]').forEach(hydrateSticky);
      initTracking();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (err) {
    console.warn('tl-blog-cta: erro inesperado, componente desativado nesta página', err);
  }
})();
